import React from "react";
import { CancelRounded, CheckCircle, Circle } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

interface ListIndicatorProps {
  active?: boolean;
  onClick?: Function;
  placeholder?: boolean;
  tooltip?: React.JSX.Element;
  disabled?: boolean;
}

const ListIndicator = ({
  ref,
  ...props
}: React.PropsWithChildren<ListIndicatorProps> & {
  ref?: React.Ref<HTMLButtonElement>;
}) => {
  const { active, onClick, placeholder, tooltip, disabled } = props;

  if (typeof active === "boolean") {
    if (onClick !== undefined) {
      return (
        <IconButton
          disabled={disabled}
          onClick={() => {
            onClick?.();
          }}
        >
          {!active ? (
            <CancelRounded
              sx={({ palette }) => ({
                color: palette.common.grey.light,
              })}
            />
          ) : (
            <CheckCircle
              sx={({ palette }) => ({
                color: palette.success.main,
              })}
            />
          )}
        </IconButton>
      );
    } else {
      return (
        <Tooltip title={tooltip ?? ""} arrow>
          {!active ? (
            <CancelRounded
              sx={({ palette }) => ({
                color: palette.common.grey.light,
              })}
              data-testid="cancel-icon"
            />
          ) : (
            <CheckCircle
              sx={({ palette }) => ({
                color: palette.success.main,
              })}
              data-testid="check-icon"
            />
          )}
        </Tooltip>
      );
    }
  }
  if (placeholder && active === undefined) {
    return (
      <Circle
        sx={({ palette }) => ({
          color: palette.background.highlight,
        })}
      />
    );
  }
  return (
    <CancelRounded
      sx={({ palette }) => ({
        color: palette.common.grey.light,
      })}
    />
  );
};

export default ListIndicator;
